
import { Vue, Component, Ref } from 'vue-property-decorator';
import EditTerminalReceiverModal from './EditTerminalReceiverModal.vue';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';

@Component({
  components: {
    EditTerminalReceiverModal,
  },
})
export default class TerminalReceiverModal extends Vue {
  visible = false;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  @Ref('editTerminalReceiverModal')
  editTerminalReceiverModal!: EditTerminalReceiverModal;

  loading = false;

  distributor: any = { id: null };

  dataSource: any[] = [];

  columns = [
    {
      title: '收货人',
      dataIndex: 'receiver',
      align: 'center',
    },
    {
      title: '收货地址',
      dataIndex: 'address',
      align: 'center',
      width: 250,
    },
    {
      title: '联系电话',
      dataIndex: 'phone',
      align: 'center',
    },
    {
      title: '是否默认',
      dataIndex: 'is_default_text',
      align: 'center',
    },
    {
      title: '状态',
      dataIndex: 'status_text',
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
      width: 140,
    },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  open(record: any) {
    this.distributor = record;
    this.visible = true;
    this.pagination.current = 1;
    this.getList();
  }

  async setAsDefault(record: any) {
    // TODO: 设为默认终端收货人
    const res = await this.supplyService.postEditDelivery(record.id, {
      is_default: 1,
    });
    if (res) {
      this.$message.success('设为默认终端收货人成功');
      this.getList();
    }
  }

  async enableReceiver(record: any) {
    // TODO: 启用终端收货人
    const res = await this.supplyService.postEditDelivery(record.id, {
      status: record.status ? 0 : 1,
    });
    if (res) {
      this.$message.success('操作成功');
      this.getList();
    }
  }

  async getList() {
    const res = await this.supplyService.getDeliveryList({
      distributor_id: this.distributor.id,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
    });
    if (res) {
      this.dataSource = res.list || [];
      this.pagination.total = res.total || 0;
    } else {
      this.dataSource = [];
      this.pagination.total = 0;
    }
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getList();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getList();
  }

  editReceiver(record: any) {
    // TODO: 编辑终端收货人
    console.log(record);
    this.editTerminalReceiverModal.open();
  }

  deleteReceiver(record: any) {
    // TODO: 删除终端收货人
    console.log(record);
  }

  handleCancel() {
    this.visible = false;
    this.dataSource = [];
    this.pagination.current = 1;
    this.pagination.total = 0;
  }
}
